import styled from '@emotion/styled';
import Card from 'storybookConfig/stories/cells/Card';
import Heading from 'storybookConfig/stories/molecules/Heading';
import Body from 'storybookConfig/stories/molecules/Body';
import Divider from 'storybookConfig/stories/molecules/Divider';
import Lottie from 'lottie-react';
import animation from '../../images/lottie/fulfilment-animation.json';
import IconTile from 'storybookConfig/stories/molecules/IconTile';
import type { IconName } from 'storybookConfig/mixins/icons';

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
`;

const Title = styled(Heading)`
  text-align: center;
  margin-bottom: 8px;
`;

const Subtitle = styled(Body)`
  text-align: center;
  color: ${({ theme }) => theme.color.bodyTextSecondary};
  margin-bottom: 32px;
`;

const ContentWrapper = styled.div`
  padding: 0 32px 32px 32px;
  text-align: center;
  max-width: 640px;
  margin: 0 auto;
`;

interface FulfillmentTimesPanelProps {
  /** The Lucide icon above the title, in an `IconTile`. */
  iconName: IconName;
  title?: string;
  subtitle?: string;
}

const FulfillmentTimesPanel = ({ iconName, title, subtitle }: FulfillmentTimesPanelProps) => (
  <Card>
    <ContentWrapper>
      <IconContainer>
        <IconTile name={iconName} />
      </IconContainer>
      <Title variant="Headings/H3">{title || 'Fulfillment Times'}</Title>
      <Subtitle>
        {subtitle || 'How long, on average, does it take to fulfill a new order?'}
      </Subtitle>
      <Divider margin="40px 0" />
      <div style={{ width: '100%', margin: '0 auto' }}>
        <Lottie animationData={animation} autoplay />
      </div>
    </ContentWrapper>
  </Card>
);

export default FulfillmentTimesPanel;
